import React, { useState } from "react";
import Connect from "../web3/Connect";
import MobileNav from "./MobileNav";
import classes from "./NavBar.module.css";
import discordImg from "../../assets/social-media-icons/discord.svg";
import twitterImg from "../../assets/social-media-icons/twitter.png";
import * as anchor from "@project-serum/anchor";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

export interface NavProps {
  candyMachineId?: anchor.web3.PublicKey;
  connection: anchor.web3.Connection;
  startDate: number;
  txTimeout: number;
  rpcHost: string;
}

const NavBar = (props: NavProps) => {
  const [open, setOpen] = useState(false);

  return (
    <div className={classes["navbar-wrapper"]}>
      <div className={classes["navbar-inner-wrapper"]}>
        <Connect
          candyMachineId={props.candyMachineId}
          connection={props.connection}
          startDate={props.startDate}
          txTimeout={props.txTimeout}
          rpcHost={props.rpcHost}
        />

        <div className={classes["navbar-socials-wrapper"]}>
          <a
            href="https://discord.gg/fpkXATuucr"
            target="_blank"
            rel="noreferrer"
          >
            <img className={classes["icon"]} src={discordImg} alt="icon" />
          </a>
          <a
            href="https://twitter.com/spacekittiesxyz"
            target="_blank"
            rel="noreferrer"
          >
            <img className={classes["icon"]} src={twitterImg} alt="icon" />
          </a>
        </div>
        <div className={classes["hide-web"]}>
          {open ? (
            <div
              onClick={() => {
                setOpen(!open);
              }}
              className={classes["links-icon"]}
              style={{ padding: "0.2rem", marginRight: "0.7rem" }}
            >
              <CloseIcon style={{ color: "white", fontSize: "2rem" }} />
            </div>
          ) : (
            <div
              onClick={() => {
                setOpen(!open);
              }}
              className={classes["links-icon"]}
              style={{
                padding: "0.2rem",
                marginRight: "0.7rem",
              }}
            >
              <MenuIcon style={{ color: "white", fontSize: "2rem" }} />
            </div>
          )}
        </div>
        <div
          style={{ marginLeft: open ? "0" : "-50rem" }}
          className={classes["mobile-nav-root"]}
        >
          <MobileNav />
        </div>
      </div>
    </div>
  );
};

export default NavBar;
